const CARD_DATA = [
  {
    Items: [
      {
        id: 1,
        title: "President",
        name: "MR SEYI ADEWUNMI",
        imageUrl: "./assets/images/members/LCC_PRESIDENT.JPEG",
        desc: " ",
        link: "/PRESIDENT",
      },
      {
        id: 2,
        title: "Vice President",
        name: "Adetayo Adegboye MBA,ACIN.ACIB.",
        imageUrl: "./assets/images/members/LCC_VICE_PRESIDENT.jpg",
        link: "/VICEPRESIDENT",
        desc: "Adetayo Adegboye MBA,ACIN.ACIB. is an associate of both the chartered insurance...",
      },
      {
        id: 3,
        title: "Secretary General",
        name: "Mrs. Damilola Ikpe ",
        imageUrl: "./assets/images/members/LCC_SEC_GENERAL.jpg",
        desc: "",
        link: "/SECRETARYGENERAL",
      },
      {
        id: 4,
        title: "Hon. Treasurer",
        name: "MR. OLUSEGUN OWADOKUN CFA, FCA",
        imageUrl: "./assets/images/members/LCC_TREASURER.jpg",
        desc: "Olusegun Owadokun is an accomplished finance and investment professional with over 25 years of experience spanning banking, credit ratings, financial advisory, corporate finance, capital markets, and executive training...",
        link: "/HONTREASURER",
      },
      {
        id: 5,
        title: "Membership Secretary",
        name: "Mr. Francis Ofordu",
        imageUrl: "./assets/images/members/LCC_MEMBERSHIP_SEC.jpg",
        desc: "Mr. Francis Ofordu is a long-standing member of Lagos Country Club since 2013 and currently serves as Membership Secretary. A seasoned banking professional with over 18 years of experience, he is passionate about enhancing member engagement, upholding club standards, and driving service excellence.",
        link: "/MEMBERSHIPSECRETARY",
      },
      {
        id: 6,
        title: "Hon, Social Secretary",
        name: "MR.OSEMOJE LATO",
        imageUrl: "./assets/images/members/LCC_SOCIAL_SECRETARY.JPEG",
        desc: "Osemoje Lato was born to the family of Mr. Roland & Mrs. Beatrice Lato of Benin City, Edo State of N...",
        link: "/HONSOCIALSECRETARY",
      },
      {
        id: 7,
        title: "SPORTS SECRETARY",
        name: "Mr. VINCENT OLUSEYE OLASOGBA ",
        imageUrl: "./assets/images/members/LCC_SPORTS SECETERARY.jpg",
        desc: "Chartered Accountant. ",
        link: "/SPORTSSECRETARY",
      },
      {
        id: 8,
        title: "Hon. Council Member ",
        name: "ARC. ABIODUN SHONIBARE",
        imageUrl: "./assets/images/members/LCC_COUNCI_MEMBER.jpg",
        desc: "Arc. Abiodun Shonibare MNIA is a licensed archictect, computational design specialist , and AI enthusiast with over a decade of experience working at the avant-grade intersection...",
        link: "/HONCOUNCILMEMBER",
      },
      {
        id: 9,
        title: "LEGAL ADVISER",
        name: "ODIAKA VINCENT IWEZE",
        imageUrl: "./assets/images/members/legaladvicer.jpeg",
        desc: "....",
        link: "/LEGALADVISER",
      },
      {
        id: 10,
        title: "GENERAL MANAGER",
        name: "Mr. TOLU EMMANUEL",
        imageUrl: "./assets/images/members/LCC_GM.jpeg",
        desc: "",
        link: "/GENERALMANAGER",
      },
      {
        id: 11,
        title: "CHAIRMAN, SNOOKER/BILLIARDS",
        name: "MR. TOMI OLURINOLA",
        imageUrl: "./assets/images/members/LCC3.jpeg",
        desc: " ",
        link: "/CHAIRMANSNOOKER",
      },
      {
        id: 12,
        title: "CHAIRMAN, SWIMMING SECTION",
        name: "ENGR. DEJI OSHIKOYA",
        imageUrl: "./assets/images/members/LCC_SWIMMING.jpg",
        desc: "",
        link: "/CHAIRMANSWIMMING",
      },
      {
        id: 13,
        title: "CHAIRMAN, TENNIS SECTION",
        name: "MR. JOHN NWOSU",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_TENNIS.jpg",
        desc: "",
        link: "/CHAIRMANTENNIS",
      },
      {
        id: 14,
        title: "LCC CHAIRMAN DARTS",
        name: "EVANG ADEKUNBI AKIN-TAYLOR",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_DARTS.jpg",
        desc: "",
        link: "/CHAIREMANDARTT",
      },
      {
        id: 15,
        title: "CHAIRMAN, BADMINTON SECTION",
        name: "MR. KAYODE BADEJO",
        imageUrl: "./assets/images/members/CHAIRMAN_BADMINTON_SECTION.jpg",
        desc: "",
        link: "/CHAIRMANBADMINTON",
      },
      {
        id: 16,
        title: "LCC CHAIRMAN TABLE TENNIS",
        name: "MR ABIODUN BAMGBADE ",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_TABLE_TENNIS.jpg",
        desc: "Abiodun Bamgbade a passionate Table Tennis player and a sociable person who cut across all members of the Section (both old and young members) and the club general. ",
        link: "/CHAIRMANTABLE",
      },
      {
        id: 17,
        title: "LCC Chairman Squash",
        name: "MR. SESAN ASANI",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_SQUASH.JPG",
        desc: "Mr. Sesan Asani is the CEO, Conlog Logistics Services Ltd & Operations Director, Conair Cargo Services Ltd...",
        link: "/CHAIRMANSQUASH",
      },
      {
        id: 18,
        title: "LCC CHAIRMAN SCRABBLE",
        name: "Mr. Abidemi Muraina-Taiwo",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_SCRABBLE.jpg",
        desc: "...........................................................................",
        link: "/CHAIRMANSCRABBLE",
      },
      {
        id: 19,
        name: "LEKAN ELUGBAJU",
        title: "LCC AEROBICS TAKEWONDO",
        imageUrl: "./assets/images/members/LCC_AEROBICS_TAKEWONDO.JPG",
        desc: "..",
        link: "/AEROBICSTAKEWONDO",
      },
      {
        id: 20,
        title: "CHAIRMAN, OTHER GAMES",
        name: "MR TUNJI AKINWANDE",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_OTHER_GAMES.jpg",
        desc: "Tunji Akinwande is currently a Director at Peers Consulting. He oversees the Finance department of Peers Consulting in addition to his Consulting job. .",
        link: "/OTHERGAME",
      },
    ],
  },
];

export default CARD_DATA;
